import React from "react";
import "./HeaderHome.scss";

import img1 from "../../assets/img/p9.jpg";

function HeaderHome() {
  return (
    <header>
      <div className="header-home">
        <div className="header-home__container">

          <div className="welcome__contain">
            <h1 className="welcome__title">Bienvenue chez La Truffe À 4 Pattes !</h1>
            <p className="welcome__text">
            Je suis Séverine, votre experte dévouée dans le monde de l'éducation canine et du pet-sitting. Mon amour pour les animaux me guide dans chaque aspect de mon travail. Avec une expérience riche et une approche centrée sur la bienveillance, j'apporte une compréhension unique à chaque interaction avec vos compagnons à quatre pattes.            </p>
            <p className="welcome__text">
            Ma mission est de fusionner passion et savoir-faire pour offrir des services personnalisés, allant au-delà de ce qui est habituellement attendu. Que ce soit pour accompagner votre chien à travers les étapes de son éducation ou pour prendre soin de lui pendant votre absence, mon objectif est de créer un environnement positif et stimulant pour chaque animal.            </p>
            <p className="welcome__text">
            Rejoignez-moi dans cette aventure où chaque animal est choyé et respecté comme un membre de la famille.            </p>
          </div>
          <div className="header-home__card">
            <h2 className="header-home__title">Coach en éducation canine<br />&amp; Pet-sitter</h2>
            <p className="header-home__text">
              Passionnée par le monde canin et les animaux de compagnie, je m'engage à prendre soin de vos compagnons à quatre pattes avec amour, tout en favorisant une éducation positive pour leur bien-être
            </p>
            <a href="/contact" className="header-home__button">Prendre rendez-vous</a>
          </div>
          <img className="img-small" src={img1} alt="Focused" />


        </div>
      </div>
    </header>
  )
    ;
}

export default HeaderHome;